import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 20px;
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
`;

export const Text = styled.div`
    display: flex;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 20px;
    width: 100%;
    max-width: 220px;
`;

export const ActionButton = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;

    button {
        width: 100%;
    }
`;
